module.exports = __webpack_public_path__ + "static/langojango-twi-language-phrasebook-93a5826f82b6aac4878a533e1397d235.png";